import React, { Component } from 'react'
import { FILE_URL,path } from './Constant';
export default class Comfort extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            images: props.data
        }
    }

    _getSliderBed = () => {
        if(this.props.data != null){
            if (this.props.data.bedroom_text != null && this.props.data.bedroom_text.length > 0) {
                return (
                    this.props.data.bedroom_text.map((item,index) => {
                        return (
                            <div className="row mb-3">
                                <div className="col-md-5">
                                    <h6>{this.props.static_text.bedroom_text} {index+1}</h6>
                                    <ul>
                                        <li>{item}</li>
                                    </ul>
                                </div>
                                <div className="col-md-7">
                                    <div className="carousel slide" id={"main-carousel-bed-"+index} data-ride="carousel">
                                         {this._bedroomIndSlider("main-carousel-bed-"+index,index+1)}
                                         {this._bedroomSlider("main-carousel-bed-"+index,index+1)}
                                    </div>
                                </div>
                            </div>
                        )
    
                    })
                )
            }
        }
       

    }

    _bedroomIndSlider = (id,number) => {
        let indexing = -1;
        if (this.props.images.other != null && Object.keys(this.props.images.other).length > 0) {
            return (
                <ol className="carousel-indicators">
                    {
                        this.props.images.other.map((item, key) => {
                            if (item.tag.includes('Bedroom '+number)) {
                            
                                if(item.image.includes(item.tag)){
                                    
                                    indexing = indexing + 1;
                                    return (
                                        <React.Fragment>
                                            <li data-target={'#'+id} data-slide-to={indexing} className={indexing == 0 ? "active" : ""}></li>
                                        </React.Fragment>
                                    )
                                }
                            }

                        })

                    }
                </ol>
            )
        }

    }

    _bedroomSlider = (id,number) => {
        let indexing = -1;
        if (this.props.images.other != null && Object.keys(this.props.images.other).length > 0) {
            return (
                <div className="carousel-inner">
                    {
                        this.props.images.other.map((item, key) => {
                            if (item.tag.includes('Bedroom '+number)) {
                              
                                if(item.image.includes(item.tag)){
                                   // console.log(item.image,item.tag);
                                    indexing = indexing + 1;
                                    return (
                                        <div className={indexing == 0 ? "carousel-item active" : "carousel-item"}>
                                            <img src={FILE_URL + 'villas/' + item.image} className="img-fluid w-100 d-block" alt={item.image} />
                                        </div>
                                    )
                                }
                            }

                        })

                    }
                </div>
            )
        }
    }
    render() {
        return (
            <div id="comfort">
                <div className="row">
                    <div className="col-md-12">
                        <h2>{this.props.static_text.for_your_cofort_text}</h2>
                        <div className="row">
                            <div className="col-md-12 wifi-img mt-2">
                                <img src={path+"images/wifi-img.png"} className="img-fluid d-block" alt="WIFI" /> <p>{this.props.data != null && this.props.data.wifi_description != null?this.props.data.wifi_description:''}</p>
                            </div>
                        </div>
                        {this._getSliderBed()}

                    </div>
                </div>
            </div>

        )
    }
}
